import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import React from 'react';
import TextField from '@material-ui/core/TextField';

import ThumbnailField from '../ImageUpload/ThumbnailField';
import HeadlineField from '../HeadlineField/HeadlineField';

const EditCarouselSlide = props => {
  const { slide } = props;

  return (
    <div className="mt4">
      <div className="row mt4">
        <div className="col-xs-4">
          <ThumbnailField
            onChange={thumbnailUrl => props.updateSlide({ thumbnailUrl })}
            showImageSpecs={false}
            thumbnailUrl={slide.thumbnailUrl}
          />
        </div>
        <div className="col-xs-8">
          <HeadlineField
            headline={slide.headline}
            onChange={evt =>
              props.updateSlide({
                headline: evt.target.value
              })
            }
          />
          <TextField
            id="description"
            label="Description"
            className="col-xs-10 mb2"
            value={slide.description}
            onChange={evt =>
              props.updateSlide({
                description: evt.target.value
              })
            }
            name="description"
            maxLength="140"
          />
          <TextField
            id="media_url"
            label="Clickout URL"
            className="col-xs-10 mb2"
            value={slide.mediaUrl}
            onChange={evt =>
              props.updateSlide({
                mediaUrl: evt.target.value
              })
            }
            name="mediaUrl"
          />
          {props.removeSlide !== null && (
            <Button onClick={props.removeSlide} color="secondary">
              Delete Slide
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

EditCarouselSlide.propTypes = {
  slide: PropTypes.shape({
    description: PropTypes.string,
    headline: PropTypes.string,
    mediaUrl: PropTypes.string,
    thumbnailUrl: PropTypes.string
  }).isRequired,
  removeSlide: PropTypes.func,
  updateSlide: PropTypes.func.isRequired
};

EditCarouselSlide.defaultProps = {
  removeSlide: null
};

export default EditCarouselSlide;
